module.exports = __webpack_public_path__ + "static/media/chat.08bdcc9c.svg";